import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { signInAnonymously } from 'firebase/auth';
import { Navbar } from './components/Navbar';
import { About } from './components/About';
import { Login } from './auth/Login'
import { Register } from './auth/Register';
import { ForgotPassword } from './auth/ForgotPassword';
import { Pricing } from './components/Pricing';
import { Signal } from './components/Feedback';
import { SEO } from './components/SEO';
import { Scanner } from './components/Scanner';
import {Profile} from './components/Profile';
import {PrivacyPolicy} from './components/PrivacyPolicy';
import "./App.css"

import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  signOut, 
  onAuthStateChanged 
} from 'firebase/auth';
import { 
  getFirestore, getDoc, doc
} from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyDXvzmciCwR3kO0VBddsUI9ukbTVA7HwBE",
  authDomain: "lucy-471317.firebaseapp.com",
  projectId: "lucy-471317",
  storageBucket: "lucy-471317.firebasestorage.app",
  messagingSenderId: "425368253910",
  appId: "1:425368253910:web:da77c011ce3badd7da6077"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const appId = firebaseConfig.appId;

const ProtectedRoute = ({ user, initializing, children }) => {
  // 1. While Firebase is still looking for a session, show nothing or a loader
  if (initializing) {
    return (
      <div className="flex items-center justify-center p-20">
        <div className="w-6 h-6 border-2 border-cyan-500/20 border-t-cyan-500 rounded-full animate-spin"></div>
      </div>
    );
  }

  // 2. If we are done initializing and there is still no user, THEN redirect
  if (user?.isAnonymous && user?.usage?.creditsUsed >= 1) {
    return <Navigate to="/login" replace />;
  }

  // 3. If there is a user, render the actual page
  return children;
};

/**
 * Main Application Shell
 */
const AppContent = () => {
  const [currentPath, setCurrentPath] = useState('/scanner');

  const [theme, setTheme] = useState(() => {
  // Check localStorage on initial load
    return localStorage.getItem('lucy-theme') || 'dark';
  });

  const isLight = theme === 'light';
  const [appCheckInstance, setAppCheckInstance] = useState(null);
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);

  const toggleTheme = () => {
    setTheme(prev => {
      const newTheme = prev === 'dark' ? 'light' : 'dark';
      localStorage.setItem('lucy-theme', newTheme); // Save choice
      return newTheme;
    });
  };

  const handleLoginSuccess = (userData) => setUser(userData);
  const handleLogout = async () => {
   try {
    await signOut(auth); // 1. Tells Firebase to delete the local session token
    setUser(null);       // 2. Clears your local React state
    setCurrentPath('/login'); // 3. Redirects the user
    console.log("Logged out successfully");
  } catch (error) {
    console.error("Error signing out:", error);
  }
  };



  // const renderRoute = () => {
  //   const props = { isLight:isLight, appCheckInstance, onNavigate: setCurrentPath, onLoginSuccess: handleLoginSuccess, db:db, appId:appId, auth:auth, user:user, handleLogout:handleLogout };
   
  //   switch (currentPath) {
  //     case '/scanner': return <Scanner {...props} />;
  //     case '/login': return <Login {...props} />;
  //     case '/register': return <Register {...props} />;
  //     case '/forgot-password': return <ForgotPassword {...props} />;
  //     case '/about': return <About {...props} />;
  //     // case '/creators': return <Protocol {...props} />;
  //     case '/pricing': return <Pricing {...props} />;
  //     case '/privacy': return <PrivacyPolicy {...props} />;
  //     case '/feedback': return <Signal {...props} />;
  //     case '/profile': return <Profile {...props} />;
  //     default: return <Scanner {...props} />;
  //   }
  // };
  const props = { isLight:isLight, appCheckInstance, 
    onNavigate: (path) => navigate(path), 
    onLoginSuccess: handleLoginSuccess, 
    db:db, appId:appId, auth:auth, user:user, 
    handleLogout:handleLogout 
  };
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
      const initApp = async () => {
      // 1. Initialize App Check First
      try {
        // Optional: Enable Debug Token for testing if needed
        // if (typeof window !== 'undefined') { window.FIREBASE_APPCHECK_DEBUG_TOKEN = true; }
        
        const appCheck = initializeAppCheck(app, {
          provider: new ReCaptchaV3Provider('6Ldt4D8sAAAAAFJ7HpPvUVI2-NlPKR67x--IOVCA'),
          isTokenAutoRefreshEnabled: true
        });
        console.log("App Check initialized successfully.");
        setAppCheckInstance(appCheck);
      } catch (e) {
        console.error("App Check Initialization failed:", e);
      }

      // 2. Initialize Authentication
    };

    initApp();

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
    if (firebaseUser) {
      // User is either Anonymous OR Logged in
      const userDocRef = doc(db, 'artifacts', appId, 'public', 'data', 'users', firebaseUser.uid);
      const userSnap = await getDoc(userDocRef);
      
      if (userSnap.exists()) {
        setUser({ ...userSnap.data(), uid: firebaseUser.uid, isAnonymous: firebaseUser.isAnonymous });
      } else {
        setUser({ uid: firebaseUser.uid, isAnonymous: firebaseUser.isAnonymous });
      }
    } else {
      // No user at all? Sign them in anonymously immediately
      await signInAnonymously(auth);
    }
    setInitializing(false);
  });
  return () => unsubscribe();
}, [db, appId]);

  return (
<div className={`min-h-screen transition-colors duration-500 selection:bg-cyan-500 selection:text-white font-sans relative overflow-x-hidden ${
      isLight ? 'bg-slate-50 text-slate-900' : 'bg-[#050507] text-slate-50'
    }`}>      
    {/* Abstract Background Elements */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        {/* Subtle Grid Overlay */}
        <div 
          className={`absolute inset-0 transition-opacity duration-500 ${isLight ? 'opacity-[0.05]' : 'opacity-[0.03]'}`} 
          style={{ 
            backgroundImage: `linear-gradient(${isLight ? '#000' : '#fff'} 1px, transparent 1px), linear-gradient(90deg, ${isLight ? '#000' : '#fff'} 1px, transparent 1px)`,
            backgroundSize: '40px 40px'
          }}
        />
        
        {/* Dynamic Glowing Nebulas */}
        <div className={`absolute top-[-20%] left-[20%] w-[100vw] h-[70vh] blur-[150px] rounded-3xl animate-pulse transition-all duration-700 ${
          isLight ? 'bg-cyan-200/40' : 'bg-cyan-500/10'
        }`} />
        <div className={`absolute bottom-[-10%] right-[10%] w-[80vw] h-[50vh] blur-[120px] rounded-3xl transition-all duration-700 ${
          isLight ? 'bg-blue-200/30' : 'bg-blue-600/5'
        }`} />
        
        {/* Horizontal Scan Line effect */}
        <div className={`absolute top-0 left-0 w-full h-[1px] scanline pointer-events-none transition-opacity duration-500 ${
          isLight ? 'bg-gradient-to-r from-transparent via-cyan-600/10 to-transparent' : 'bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent'
        }`} />
      </div>
      <SEO />
      
      <div className="max-w-xl mx-auto p-6 flex flex-col items-center">
        <Navbar 
          currentPath={location.pathname} 
          onNavigate={(path) => navigate(path)}
          isLight={isLight} 
          onToggleTheme={toggleTheme}
          user={user} />

        {initializing &&
           (
            <div className={`min-h-screen ${isLight ? 'bg-slate-50' :  "bg-[#050507]"}  flex items-center justify-center`}>
              <div className="flex flex-col items-center gap-4">
                {/* Simple CSS Spinner */}
                <div className="w-8 h-8 border-4 border-cyan-500/20 border-t-cyan-500 rounded-full animate-spin"></div>
                <p className={`text-[10px] md:text-xs font-mono uppercase tracking-[0.4em] ${isLight ? 'text-slate-900' : 'text-white'} animate-pulse`}>
                  Syncing Session...
                </p>
              </div>
            </div>
          )
        }
        <main className="w-full">
          <header className="mb-12 text-center">
            <h2 className={`text-4xl font-black md:text-6xl tracking-tighter mb-2 italic ${isLight ? 'text-slate-900' : 'text-slate-50'}`}>
              LUCY
            </h2>
            <h2 className={`text-xl md:text-3xl font-black tracking-tighter mb-2 italic ${isLight ? 'text-slate-900' :  'text-slate-300'}`}>
              Know What You Click
            </h2>
            
          </header>
          <Routes>
          <Route 
              path="/scanner" 
              element={
                <ProtectedRoute user={user} initializing={initializing}>
                  <Scanner {...props} />
                </ProtectedRoute>
              } 
            />            
            <Route path="/login" element={<Login {...props} />} />
            <Route path="/register" element={<Register {...props} />} />
            <Route path="/forgot-password" element={<ForgotPassword {...props} />} />
            <Route path="/about" element={<About {...props} />} />
            <Route path="/pricing" element={<Pricing {...props} />} />
            <Route path="/privacy" element={<PrivacyPolicy {...props} />} />
            <Route path="/feedback" element={<Signal {...props} />} />
            <Route 
                path="/profile" 
                element={
                  <ProtectedRoute user={user} initializing={initializing}>
                    <Profile {...props} />
                  </ProtectedRoute>
                } 
              />            
            {/* Catch-all: redirects any unknown path to scanner */}
           <Route 
              path="*" 
              element={
                <ProtectedRoute user={user} initializing={initializing}>
                  <Scanner {...props} />
                </ProtectedRoute>
              } 
            />    
          </Routes>
        </main>

        <footer className="mt-20 text-center opacity-50">
          <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-[10px] font-mono uppercase tracking-[0.4em]">
            <span>&copy; 2025 0xDAGCORP</span>
            <span className="hidden md:block opacity-80">|</span>
            <button 
              onClick={() => navigate('/privacy')}
              className={`hover:opacity-100 transition-opacity underline-offset-4 hover:font-bold ${currentPath === '/privacy' ? 'opacity-100 font-bold text-cyan-500' : 'opacity-90'}`}
            >
              Privacy Policy
            </button>
          </div>
        </footer>
      </div>

      <style>{`
        @keyframes reveal {
          from { opacity: 0; filter: blur(8px); transform: translateY(8px); }
          to { opacity: 1; filter: blur(0); transform: translateY(0); }
        }
        .animate-in { animation: reveal 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
      `}</style>
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;